module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAIAAAAjCAYAAAC+Rtu3AAAAo0lEQVQoU1WQKw7CYBCEZ/8Eh4YT9AYcgTtwCA5RBKYKAYK1GAgaR4Jugq2srGuCaQiGdMk2wwbcl519zKyYmQKA2PtF6FpF8sqjVphDc6dUXwnVkVBu2XzLWbksCecF4TAn7GeETaZAD7FiohA/sR5TWo0o5ekLUCBBLKRoLqYcHxb6njgRR8NGGAur5U6RDGLVSQEHDzhk98j/T3i2P4/qgQ9bCmpLvz6JKQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon70o@2x.png
// module id = 424
// module chunks = 1